import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { paiementService } from '../services/api';
import { notify } from '../components/NotificationContainer';

const PaiementCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [status, setStatus] = useState('processing'); // processing, success, error
    const [message, setMessage] = useState('Traitement du paiement en cours...');

    useEffect(() => {
        const processCallback = async () => {
            // Extraire les paramètres de l'URL
            const searchParams = new URLSearchParams(location.search);
            const paiementId = searchParams.get('paiement_id');
            const error = searchParams.get('error');

            // Paramètres Hello Asso
            const orderId = searchParams.get('orderId');
            const checkoutIntentId = searchParams.get('checkoutIntentId');
            const code = searchParams.get('code');
            const token = searchParams.get('token');  // Token de sécurité requis

            if (!paiementId) {
                setStatus('error');
                setMessage('Paramètres manquants pour le traitement du paiement.');
                return;
            }

            if (error === 'Client cancelled' || code === 'cancel') {
                setStatus('error');
                setMessage('Vous avez annulé le paiement.');
                setTimeout(() => {
                    navigate('/inscriptions');
                }, 3000);
                return;
            }

            try {
                // Appeler l'API pour valider le callback
                const response = await paiementService.callbackHelloAsso({
                    paiement_id: paiementId,
                    orderId,
                    checkoutIntentId,
                    code,
                    token  // Token de sécurité requis par le backend
                });

                if (response.data.status === 'success' || response.data.status === 'valide') {
                    setStatus('success');
                    setMessage('Votre paiement a été validé avec succès !');
                    notify.success('Paiement validé !');

                    // Redirection vers l'inscription après 3 secondes
                    setTimeout(() => {
                        navigate('/inscriptions');
                    }, 3000);
                } else {
                    setStatus('error');
                    setMessage(response.data.message || 'Le paiement n\'a pas pu être validé.');
                    notify.error(response.data.message || 'Erreur de validation');
                }

            } catch (err) {
                console.error('Erreur callback paiement:', err);
                setStatus('error');
                setMessage(err.response?.data?.message || 'Une erreur est survenue lors de la validation du paiement.');
                notify.error('Une erreur est survenue lors de la validation du paiement.');
            }
        };

        processCallback();
    }, [location, navigate]);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 text-center">

                    {status === 'processing' && (
                        <div className="flex flex-col items-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mb-4"></div>
                            <h2 className="text-xl font-medium text-gray-900">Vérification du paiement...</h2>
                            <p className="mt-2 text-sm text-gray-500">{message}</p>
                        </div>
                    )}

                    {status === 'success' && (
                        <div className="flex flex-col items-center">
                            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                                <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-medium text-green-900">Paiement Réussi !</h2>
                            <p className="mt-2 text-sm text-green-600">{message}</p>
                            <p className="mt-4 text-xs text-gray-400">Vous allez être redirigé automatiquement...</p>
                            <button
                                onClick={() => navigate('/inscriptions')}
                                className="mt-6 w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                            >
                                Retour aux inscriptions
                            </button>
                        </div>
                    )}

                    {status === 'error' && (
                        <div className="flex flex-col items-center">
                            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                                <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-medium text-red-900">Échec du paiement</h2>
                            <p className="mt-2 text-sm text-red-600">{message}</p>
                            <button
                                onClick={() => navigate('/inscriptions')}
                                className="mt-6 w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                            >
                                Retour aux inscriptions
                            </button>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default PaiementCallback;
